import Cookies from 'js-cookie';

export const RCORE_COOKIE = 'rcore';
export const THEME_COOKIE = 'SumtTheme';

const parseCookie = (cookieName, delimiter) => {
  const cookie = Cookies.get(cookieName);
  const keyValueMap = new Map();
  if (cookie) {
    const pairs = cookie.split('&');
    if (pairs) {
      pairs.forEach((pair) => {
        const p = pair.split(delimiter);
        keyValueMap.set(p[0], p[1]);
      });
    }
  }
  return keyValueMap;
};

const setCookieValue = (key, value) => {
  const keyValueMap = parseCookie(RCORE_COOKIE, ':');
  // updated the value
  keyValueMap.set(key, value);
  const cookie = [];
  keyValueMap.forEach((v, k) => {
    const pair = `${k}:${v}`;
    cookie.push(pair);
  });
  Cookies.set(RCORE_COOKIE, cookie.join('&'));
};

const getCookieValue = (key) => {
  const keyValueMap = parseCookie(RCORE_COOKIE, ':');
  return keyValueMap.get(key);
};

const getThemeCookieKeyValue = (key) => {
  const keyValueMap = parseCookie(THEME_COOKIE, '=');
  if (keyValueMap.size > 0) {
    return keyValueMap.get(key);
  }
  return null;
};

const setKeyValueInThemeCookie = (key, value) => {
  const keyValueMap = parseCookie(THEME_COOKIE, '=');
  keyValueMap.set(key, value);
  const cookie = [];
  keyValueMap.forEach((v, k) => {
    const pair = `${k}=${v}`;
    cookie.push(pair);
  });
  Cookies.set(THEME_COOKIE, cookie.join('&'));
};

const removeCookie = (name) => {
  Cookies.remove(name);
};

export {
  parseCookie,
  setCookieValue,
  getCookieValue,
  getThemeCookieKeyValue,
  setKeyValueInThemeCookie,
  removeCookie
};
